import React from "react";
import "./presetColorPicker.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/pro-solid-svg-icons";

interface IPresetColorPicker {
  onClick: (codeColors: string) => void;
  colorValue: string;
  compact?: boolean;
  customAction?: React.ReactNode;
  customActionSelected?: boolean;
  customActionOnClick?: () => void;
}

export const PRESET_COLORS = [
  "#7357D6",
  "#C6B7F7",
  "#B846C3",
  "#E9ACE8",
  "#1B94FD",
  "#88C6F7",
  "#2CDFFD",
  "#5BCEEC",
  "#1BAA5A",
  "#87CE9B",
  "#FEAB2D",
  "#FAC35B",
  "#FE2889",
  "#F7A8C9",
  "#F73952",
  "#F6A7A7",
];

export default function PresetColorPicker(props: IPresetColorPicker) {
  function handleColorPick(codeColors: string) {
    props.onClick(codeColors);
  }

  return (
    <div className={props.compact ? "colorsContainer-compact" : "colorsContainer-regular"}>
      {PRESET_COLORS.map((codeColors, index) => {
        return (
          <div
            key={index}
            className={"colorContainer " + (codeColors === props.colorValue ? "colorContainer-selected" : "")}
            onClick={() => handleColorPick(codeColors)}
          >
            <div className={props.compact ? "colors-compact" : "colors-regular"} style={{ backgroundColor: codeColors }}>
              {codeColors === props.colorValue ? (
                <FontAwesomeIcon
                  icon={faCheck}
                  className={props.compact ? "color-icon-compact" : "color-icon-regular"}
                  style={{ color: "#FFFFFF" }}
                />
              ) : null}
            </div>
          </div>
        );
      })}
      {props.customAction != null && (
        <div
          className={
            "colorContainer colorContainer-custom-action " + (props.customActionSelected ? "colorContainer-selected" : "")
          }
          onClick={props.customActionOnClick}
        >
          {props.customAction}
        </div>
      )}
    </div>
  );
}
